/**
 * Holds the current WebSocket state (opened/closed).
 *
 * Created by tschlieder on 03.02.2016.
 */
import { produce } from 'immer'
import { PUSH_OPENED, PUSH_CLOSED, PUSH_STARTED, PUSH_STOPPED } from '../actions/push'

const INITIAL_STATE = {
    opened: false, // WebSocket is open
    pushing: false // Server is instructed to push data
}

// The reducer
export default produce((draft, action) => {
    switch (action.type) {
        case PUSH_OPENED: {
            draft.opened = true
            break
        }
        case PUSH_CLOSED: {
            draft.opened = false
            break
        }
        case PUSH_STARTED: {
            draft.pushing = true
            break
        }
        case PUSH_STOPPED: {
            draft.pushing = false
            break
        }
        default:
            break
    }
}, INITIAL_STATE)
